import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Add as AddIcon,
  ListAlt as ListAltIcon,
  PostAdd as PostAddIcon,
  CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import {
  canCreateCountry,
  canUseOnboardingRequests
} from "../../../../auth/permissions";
import { useRoles } from "../../../../auth/useRoles";

type Props = {};

export const CountriesGridMenu: FC<Props> = () => {
  const roles = useRoles();
  const location = useLocation();
  const showCreateCountry = canCreateCountry(roles);
  const showOnboardingRequests = canUseOnboardingRequests(roles);
  const isCompletedPage = location.pathname.startsWith("/countries/completed");

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
        <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
          {isCompletedPage
            ? "Completed Country Additions"
            : "Country Additions"}
        </Typography>
      </Box>
      <Box display="flex" gap={1}>
        {!isCompletedPage && (
          <Link to="/countries/completed">
            <Button
              variant="outlined"
              startIcon={<CheckCircleIcon color="success" />}
            >
              Completed
            </Button>
          </Link>
        )}
        {showOnboardingRequests && !isCompletedPage && (
          <>
            <Link to="/countries/request-new">
              <Button variant="outlined" startIcon={<PostAddIcon />}>
                Request
              </Button>
            </Link>
            <Link to="/countries/my-requests">
              <Button variant="outlined" startIcon={<ListAltIcon />}>
                My requests
              </Button>
            </Link>
          </>
        )}
        {showCreateCountry && !isCompletedPage && (
          <Link to="/countries/new">
            {/* The "Onboard new TC" / "Onboard new broker" slot. Board comment #43 asked for
                "Request Country Addition"; the wording was settled as below instead. */}
            <Button variant="contained" startIcon={<AddIcon />}>
              Onboard New Country Addition
            </Button>
          </Link>
        )}
      </Box>
    </Box>
  );
};
